module.exports = import("https://www.springer.com/gp/book/9789811625961");;